import { FC, useEffect, useState, lazy } from "react";
import CustomerLayout from "../layouts/CustomerLayout";
import ResellerLayout from "../layouts/ResellerLayout";
import EmployeeLayout from "../layouts/EmployeeLayout";
import CenterCircularProgress from "ui-modules/components/Spinner/CenterCircularProgress/CenterCircularProgress";
import rest from "ui-modules/utils/rest";
import AuthStorage from "ui-modules/utils/AuthStorage";
import { useHistory } from "react-router-dom";
import customerRoutes from "../routes/CustomerRoutes";
import resellerRoutes from "../routes/ResellerRoutes";
import useRoutes from "ui-modules/commons/hooks/use-routes";
import useGlobal from "ui-modules/commons/hooks/use-global";
import useNotification from "ui-modules/commons/hooks/use-notification";
import Image from "../assets/fonts/www.svg";
import { customerInitialRests, resellerInitialRests } from "../configs/initialRests";
import CreateRoutes from "ui-modules/components/Navigation/Routes/CreateRoutes";
import { usePageTracking } from "../assets/common/hooks/usePageTracking";
import { initializeGTM } from "../utils/gtm";
const LimitedPortalCard = lazy(() => import("../components/LimitedPortalCard"));

enum PersonType {
  CUSTOMER = "CUSTOMER",
  EMPLOYEE = "EMPLOYEE",
  RESELLER = "RESELLER",
}

const filterByRole = (routes: any = []) => {
  return routes.map((item: Record<any, any>) => {
    if (!item.roles) {
      return {
        ...item,
        routes: item?.routes ? filterByRole(item?.routes || []) : [],
      };
    }

    const hasGlobal = item?.roles?.includes("GLOBAL");
    const hasLimited = item?.roles?.includes("LIMITED");

    const filteredRoutes: Record<any, any>[] = item?.routes ? filterByRole(item?.routes) : [];

    if (filteredRoutes?.length > 0) {
      return {
        ...item,
        routes: filteredRoutes,
      };
    } else {
      return {
        ...item,
        component: hasGlobal
          ? (props: any) => (
              <LimitedPortalCard path={item.path}>
                <item.component {...props} />
              </LimitedPortalCard>
            )
          : hasLimited
          ? LimitedPortalCard
          : item.component,
      };
    }
  });
};

const MainApp: FC = () => {
  const history = useHistory();
  const { setRoutes } = useRoutes();
  const { setGlobal } = useGlobal();
  const notification = useNotification();

  const [state, setState] = useState<{
    personType?: PersonType | null;
    balance: number;
    lastUnReadMsg?: Record<any, any>[];
  }>({
    personType: null,
    balance: 0,
    lastUnReadMsg: [],
  });

  const handleOpenWebSite = () => window.open("https://www.zi-tel.com/");

  // const handleIntroduction = () => history.push("/introduction");

  //TODO Move to Ui-Modules
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      initializeGTM();
    }
    rest
      .get(`${process.env.REACT_APP_BSS_SERVICE}/api/portal/people/me/type`)
      .then((resp) => {
        if (resp.data === "CUSTOMER") {
          // rest.get(`${process.env.REACT_APP_BSS_SERVICE}/api/portal/customers/me/balance`).then((respBalance) => {
          //   const balance = respBalance?.data?.balance || 0;
          //   if (balance < 0) {
          //     notification.info({
          //       title: "تسویه بدهی",
          //       message: "لطفا، جهت تسویه بدهی کلیک کنید.",
          //       onClick: () => {
          //         history.replace("/financial/payment-debt");
          //       },
          //       key: "payment-debt",
          //       appBar: true,
          //       notification: false,
          //       // renderIcon: <Icon name={"paid"} className={"drawerIcons large"} />
          //     });
          //   }
          // });

          customerInitialRests().then((customerInitial) => {
            const hasError = customerInitial?.me?.error;
            if (hasError) {
              handleError();
            } else {
              customerRoutes.unshift(
                {
                  title: "وب سایت",
                  sidebar: true,
                  iconTag: <img src={Image} style={{ width: 30, height: 30 }} alt="وبسایت زی‌تل" />,
                  onClick: handleOpenWebSite,
                  onlyInMobile: true,
                  roles: ["GLOBAL"],
                }
                /* {
                  title: "معرفی به دوستان",
                  sidebar: true,
                  iconTag: <Icon name={"share"} className={"drawerIcons large"} />,
                  onClick: handleIntroduction,
                  onlyInMobile: true,
                }*/
              );

              const roles = customerInitial?.tokensMe?.roles || [];
              const result: Record<any, any>[] = roles.includes("LIMITED_PORTAL")
                ? filterByRole(customerRoutes)
                : [...customerRoutes];

              setGlobal({ me: customerInitial.me, tokensMe: customerInitial.tokensMe });
              setRoutes([...result]);
              setState((prevState) => ({
                ...prevState,
                personType: PersonType.CUSTOMER,
                balance: customerInitial?.balanceMe || 0,
                lastUnReadMsg: customerInitial?.lastUnreadMsgMe || [],
              }));
            }
          });
        } else if (resp.data === "RESELLER") {
          resellerInitialRests().then((resellerInitial) => {
            const hasError = resellerInitial?.me?.error || resellerInitial?.tokensMe?.error;
            if (hasError) {
              handleError();
            } else {
              setGlobal({ me: resellerInitial.me, tokensMe: resellerInitial.tokensMe });
              setRoutes(resellerRoutes);
              setState((prevState) => ({ ...prevState, personType: PersonType.RESELLER }));
            }
          });
        } else if (resp.data === "EMPLOYEE") {
          // employeeInitialRests().then(() => {
          handleError();
          // const hasError = employeeInitial?.me?.error;
          // if (hasError) {
          //   handleError();
          // } else {
          //   setGlobal({ me: employeeInitial.me });
          //   setRoutes(employeeRoutes);
          //   setState((prevState) => ({ ...prevState, personType: PersonType.EMPLOYEE }));
          // }
          // });
        }
      })
      .catch(() => {
        handleError();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  usePageTracking();

  const handleError = () => {
    notification.error({ message: "خطا، لطفا دوباره تلاش کنید." });
    rest.delete(`${process.env.REACT_APP_AUTH_SERVICE}/auth/revoke`).then(() => {});
    AuthStorage.removeLocalAuthToken();
    AuthStorage.removeSessionAuthToken();
    history.replace({ pathname: "/auth/login" });
  };

  let routesByPersonType;
  switch (state.personType) {
    case PersonType.CUSTOMER:
      routesByPersonType = (
        <CustomerLayout balanceMe={state.balance} lastUnReadMsgMe={state.lastUnReadMsg}>
          <CreateRoutes />
        </CustomerLayout>
      );
      break;
    case PersonType.RESELLER:
      routesByPersonType = (
        <ResellerLayout>
          <CreateRoutes />
        </ResellerLayout>
      );
      break;
    case PersonType.EMPLOYEE:
      routesByPersonType = (
        <EmployeeLayout>
          <CreateRoutes />
        </EmployeeLayout>
      );
      break;
    default:
      routesByPersonType = <CenterCircularProgress />;
  }

  return routesByPersonType;
};

export default MainApp;
